import zxcvbn from 'zxcvbn';

const baseURL = window.location.protocol + '//' + window.location.host;

export const EnvName = () => {
    const host = window.location.host;
    if (/\.top$/.test(host)) {
        return 'staging';
    } else if (/\.local$/.test(host)) {
        return 'local';
    } else {
        return 'production';
    }
};

export const User = ['$resource', ($resource) => {
    const URL = baseURL + '/api/user/:id';
    return $resource(URL);
}];

export const Organisation = ['$resource', ($resource) => {
    const URL = baseURL + '/api/organisation/:email';
    return $resource(URL);
}];

export const Organisations = ['$resource', ($resource) => {
    const URL = baseURL + '/api/organisations';
    return $resource(URL);
}];

export const HelpTexts = ['$resource', ($resource) => {
    const URL = baseURL + '/api/help-texts';
    return $resource(URL);
}];

export const SubdomainAvailability = ['$resource', ($resource) => {
    const URL = baseURL + '/api/organisation/subdomain-available/:subdomain/:id';
    return $resource(URL);
}];

export const Roles = ['$resource', ($resource) => {
    const URL = baseURL + '/api/roles';
    return $resource(URL);
}];

export const Tags = ['$resource', ($resource) => {
    const URL = baseURL + '/api/tags';
    return $resource(URL);
}];

export const Image = ['$resource', ($resource) => {
    const URL = baseURL + '/api/images/create';
    return $resource(URL);
}];

export const Definitions = ['$resource', ($resource) => {
    const URL = baseURL + '/api/definitions';
    return $resource(URL);
}];

export const DefinitionTitleAvailability = ['$resource', ($resource) => {
    const URL = baseURL + '/api/definitions/title-available/:title/:id';
    return $resource(URL);
}];

export const Definition = ['$resource', ($resource) => {
    const URL = baseURL + '/api/definition/:id';
    return $resource(URL);
}];

export const Favourites = ['$resource', ($resource) => {
    const URL = baseURL + '/api/definitions/favourites';
    return $resource(URL);
}];

export const ChecklistsInProgress = ['$resource', ($resource) => {
    const URL = baseURL + '/api/checklists/:definition';
    return $resource(URL);
}];

export const ChecklistsSignedOrSubmitted = ['$resource', ($resource) => {
    const URL = baseURL + '/api/checklists/:definition';
    return $resource(URL);
}];

export const ChecklistSearch = ['$resource', ($resource) => {
    const URL = baseURL + '/api/search/checklists';
    return $resource(URL);
}];

export const Checklist = ['$resource', ($resource) => {
    const URL = baseURL + '/api/checklist/:id';
    return $resource(URL);
}];

export const Signing = ['$resource', ($resource) => {
    const URL = baseURL + '/api/checklist/sign/:id';
    return $resource(URL);
}];

export const SignatureRemoving = ['$resource', ($resource) => {
    const URL = baseURL + '/api/checklist/remove-signature/:id/:role';
    return $resource(URL);
}];

export const StripeSetupIntent = ['$resource', ($resource) => {
    const URL = baseURL + '/api/stripe/create-setup-intent';
    return $resource(URL);
}];

export const StripeSubscription = ['$resource', ($resource) => {
    const URL = baseURL + '/api/stripe/create-subscription';
    return $resource(URL);
}];

export const StripeCardUpdate = ['$resource', ($resource) => {
    const URL = baseURL + '/api/stripe/update-card';
    return $resource(URL);
}];

export const StripeCardRemove = ['$resource', ($resource) => {
    const URL = baseURL + '/api/stripe/remove-card';
    return $resource(URL);
}];

export const StripeConfiguration = ['$resource', ($resource) => {
    const URL = baseURL + '/api/stripe/get-configuration';
    return $resource(URL);
}];

export const Notifications = ['$resource', ($resource) => {
    const URL = baseURL + '/api/user/set-notifications';
    return $resource(URL);
}];

export const Zxcvbn = () => {
    return {
        score: function() {
            const compute = zxcvbn.apply(null, arguments);
            return compute && compute.score;
        }
    };
};

export const Socket = ['socketFactory', 'config', (socketFactory, config) => {
    let serverUrl = config.socket.url;
    const jwt = ('; ' + document.cookie).split('; ' + config.jwt.cookieName + '=').pop().split(';').shift();
    const socket = socketFactory({
        ioSocket: window.io(serverUrl, {
            query: 'auth_token=' + jwt
        })
    });
    socket.on('error', (err) => {
        console.log(err)
    });
    return socket;
}];
